module.exports = __webpack_public_path__ + "img/food-25.20dc125c.jpg";